import { render } from "./BarcodeScanInterceptor.vue?vue&type=template&id=1f48a587"
import script from "./BarcodeScanInterceptor.vue?vue&type=script&lang=js"
export * from "./BarcodeScanInterceptor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__